import React from 'react';

import { useIntl } from 'react-intl';

import ShowMoreIcon from '@atlaskit/icon/core/align-text-left';

import type { GlobalShortcutsProps, ViewAllAppsConfig } from '../../types';
import { ShortcutMenuItem } from '../shortcut-menu-item';

import { messages } from './messages';

export type ViewAllAppsItemProps = Pick<GlobalShortcutsProps, 'product'> & ViewAllAppsConfig;

export function ViewAllAppsItem({ path, isSelected, product, onNavigate }: ViewAllAppsItemProps) {
	const { formatMessage } = useIntl();
	const analyticsName = 'VIEW_ALL_APPS';

	if (!path || path.trim().length < 1) {
		return null;
	}

	return (
		<ShortcutMenuItem
			shortcut={{
				key: analyticsName,
				analyticsName: analyticsName,
				label: formatMessage(messages.viewAllAppsLabel),
				icon: <ShowMoreIcon label="" />,
				url: path,
				isReorderable: false,
				type: 'internal',
				isSelected: isSelected,
				onClick: onNavigate,
			}}
			product={product}
		/>
	);
}
